import { Avatar as Component } from "./Avatar";
import Badge from "./components/Badge/AvatarBadge";
import Counter from "./components/Counter/AvatarCounter";
import Gift from "./components/Gift/AvatarGift";
import OnlineIndicator from "./components/OnlineIndicator/AvatarOnlineIndicator";
import Stub from "./components/Stub/AvatarStub";
import Tag from "./components/Tag/AvatarTag";

export interface IAvatarExtensions {
    Counter: typeof Counter;
    OnlineIndicator: typeof OnlineIndicator;
    Badge: typeof Badge;
    Gift: typeof Gift;
    Tag: typeof Tag;
    Stub: typeof Stub;
}

export const Avatar: typeof Component & IAvatarExtensions = Object.assign(
    Component,
    {
        Counter,
        OnlineIndicator,
        Badge,
        Gift,
        Tag,
        Stub,
    },
);

export type { AvatarProps, AvatarSize } from "./types";
